// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ConfirmationPaymentMethod extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  static Methods = {
    Northpoint: 1,
    COD: 2,
    ACH: 3,
    DealerAccountTerms: 4,
    RedOak: 5
  }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  deleted?: Date;
  displayOrder?: number;
  name?: string;
  paymentTerms?: string;
  requiresAch!: boolean;
  requiresNorthpoint!: boolean;
  visibleToChannelPartner!: boolean;
  winterOrder!: boolean;
}

